/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateAutomationForFlow} from '../api'

export const useMutationUpdateAutomationForFlow = createReactQueryMutationHook('updateAutomationForFlow', updateAutomationForFlow)
